import { GetWorkAreasDocument, GetWorkAreasQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkAreaNodes = GetWorkAreasQuery['locations']['workAreas']
export type WorkAreaNode = WorkAreaNodes[0]

export const useWorkAreas = ({
  locationIds,
  onlyNonArchived,
}: {
  locationIds?: number[]
  onlyNonArchived?: boolean
}) => {
  const { loading, data, error } = useQuery(GetWorkAreasDocument, {
    variables: { locationIds, onlyNonArchived },
  })

  return {
    loading,
    workAreas: data ? data.locations.workAreas : [],
    error,
  }
}
